/**
 * APEX analytics/shared.jsx
 * Helpers et primitives locaux pour les sections analytics.
 */
import React from 'react';

// Card et EmptyState viennent du design-system
export { default as Card } from '../../design-system/Card';
export { default as EmptyState } from '../../design-system/EmptyState';

// SectionHeader conservé en local (API différente de SectionLabel : title/subtitle/icon props)
export const SectionHeader = ({ title, subtitle, icon: Icon }) => (
  <div className="flex items-start gap-3 mb-4">
    <div className="w-1 h-10 bg-gradient-to-b from-cyan-400 to-fuchsia-400 flex-shrink-0" />
    <div>
      <div className="flex items-center gap-2">
        {Icon && <Icon size={14} className="text-cyan-400" />}
        <h3 className="text-[10px] tracking-[0.4em] text-zinc-400 uppercase font-semibold">{title}</h3>
      </div>
      {subtitle && <div className="text-xs text-zinc-500 mt-1 font-mono">{subtitle}</div>}
    </div>
  </div>
);

export const ChartTooltip = ({ active, payload, label }) => {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="bg-zinc-950 border border-cyan-400/30 p-3 text-xs font-mono shadow-xl">
      {label !== undefined && <div className="text-zinc-500 mb-2 tracking-wider">{label}</div>}
      {payload.map((p, i) => (
        <div key={i} className="flex items-center gap-2 text-white">
          <div className="w-2 h-2" style={{ background: p.color }} />
          <span className="text-zinc-400">{p.name}:</span>
          <span className="font-bold">{typeof p.value === 'number' ? (Number.isInteger(p.value) ? p.value : p.value.toFixed(1)) : p.value}</span>
        </div>
      ))}
    </div>
  );
};

export const MetricTile = ({ label, value, unit, subtext, color = 'cyan' }) => {
  const colors = {
    cyan: 'text-cyan-400', fuchsia: 'text-fuchsia-400', emerald: 'text-emerald-400',
    amber: 'text-amber-400', rose: 'text-rose-400', white: 'text-white'
  };
  return (
    <div className="border border-zinc-800 bg-zinc-950 p-4">
      <div className="text-[10px] tracking-[0.3em] text-zinc-500 uppercase font-semibold mb-1">{label}</div>
      <div className="flex items-baseline gap-1">
        <span className={`text-3xl font-black ${colors[color]}`}>{value}</span>
        {unit && <span className={`${colors[color]} text-sm font-mono`}>{unit}</span>}
      </div>
      {subtext && <div className="text-[10px] text-zinc-500 font-mono mt-1">{subtext}</div>}
    </div>
  );
};

export const Insight = ({ children, variant = 'info' }) => {
  const variants = {
    info: 'border-cyan-400/40 bg-cyan-400/5 text-cyan-100',
    warning: 'border-amber-400/40 bg-amber-400/5 text-amber-100',
    success: 'border-emerald-400/40 bg-emerald-400/5 text-emerald-100',
    danger: 'border-rose-400/40 bg-rose-400/5 text-rose-100'
  };
  return <div className={`border-l-4 p-3 text-sm ${variants[variant]}`}>{children}</div>;
};

export const CHART_COLORS = {
  cyan: '#22d3ee', fuchsia: '#e879f9', emerald: '#34d399',
  amber: '#fbbf24', rose: '#fb7185', zinc: '#71717a'
};
